import SliderRound from "../common/slider-round";
export const CheckBox = ({
    show,
    dataModel, 
    name, label, 
    onChange, 
    showWarning, 
    warningText
})=>{
    if (!show) return null;

    dataModel = dataModel || {};
    const value = !!dataModel[name];

    const onChangeHandler = (event) => {
        onChange && onChange({
            target: {
                name,
                value: event.target.checked
            }
        });
    };

        return (
            <>
                <div className="mb-4 flex items-center justify-between mt-[20px] border-b border-[#252632] pb-3">
                    <span className="font-body-primary text-base font-[300]">{label || name}</span>
                    <SliderRound
                        checked={value}
                        onChange={onChangeHandler}
                        id={name}
                        name={name}
                    />
                </div>
                {showWarning ? (
                    <div>
                        <span
                            style={{
                                display: "inline-block",
                                marginBottom: "15px"
                            }}
                            className="alert alert-warning"
                        >
                            <i className="bi bi-exclamation-triangle-fill"></i>
                            <span style={{ marginLeft: "10px" }}>{warningText}</span>
                        </span>
                    </div>
                ) : null}
            </>
        );
};